import { render } from "./GiftHome.vue?vue&type=template&id=32a91078"
import script from "./GiftHome.vue?vue&type=script&lang=js"
export * from "./GiftHome.vue?vue&type=script&lang=js"

import "./GiftHome.vue?vue&type=style&index=0&id=32a91078&lang=scss"
script.render = render

export default script